import { CheckCircle, Error } from '@mui/icons-material';

export function AssetOnlineStatus({
  deviceStatus,
}: {
  deviceStatus: string | boolean;
}) {
  if (deviceStatus === 'Online' || deviceStatus === 'Recently Online')
    return (
      <CheckCircle
        sx={{
          color: deviceStatus === 'Online' ? '#008001' : '#6888D6',
          fontSize: '16px',
        }}
      />
    );
  if (deviceStatus === 'Offline')
    return (
      <Error
        sx={{
          color: '#F47C01',
          fontSize: '16px',
        }}
      />
    );
  return (
    <Error
      sx={{
        color: '#8B0000',
        fontSize: '16px',
      }}
    />
  );
}

export default AssetOnlineStatus;
